export { default } from './TabNav';



// WEBPACK FOOTER //
// ./src/client/js/view/components/TabNav/index.js